import { LineChartModel } from '../models/chart/line-chart.model';
import { ChartStylingModel } from '../models/chart/chart-styling.model';

export const /** @type {?} */ LineChartTemplates = {
  defaultTemplate: {
    property: new LineChartModel({
      display: true,
      disable: false,
      autoScale: true,
      gradient: false,
      showLegend: true,
      legendPosition: 'right',
      chartAlignment: 'start',
      colorSchemeName: 'forest',
      colorScheme: {
        domain: []
      },
      showXAxis: true,
      showYAxis: true,
      showXAxisLabel: true,
      showYAxisLabel: true,
      xAxisLabel: '',
      yAxisLabel: '',
    }),
    style: new ChartStylingModel({
      barsContainerWidth: '100%',
      barsContainerHeight: '200px'
    })
  }
}
